import Layout from "../cponents/layout";
import { useEffect, useState } from "react";
import BaseEndpoint from "../endpoints/baseEndpoint";

export default function Contact() {
    const [data, setData] = useState(null);

    useEffect(() => {
        BaseEndpoint.instance().get('/web-instruction/contact').then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }
        });
    }, []);

    return (
        <Layout>
            <div className="container py-5" dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
        </Layout>
    )
}